export const ButtonFields = `
	...,
	"pageType": reference->_type,
	"slug": reference->slug.current,
	anchor,
	newWindow,
`;
